<script>
import RecruitInfo from "@/components/career/RecruitInfo.vue";
import RecruitLink from "@/components/career/RecruitLink.vue";

export default {
  name: "RecruitContent",
  components: {RecruitLink, RecruitInfo },
  props: {
    sort: {type: String, default: "01"},
    title: {type: String, default : ''},
    tags: {type: String, default: ''},
    joinYear: {type: String, default: '2020'},
    office: {type: String, default: ''},
    name: {type: String, default: ''},
    banner: { type: String, default: "" },
    bannerSp: { type: String, default: '' },
    description01: {type: String, default: ''},
    description02: {type: String, default: ''},
    description03: { type: String, default: '' },
    answerHeading01: { type: String, default: '' },
    answerParagraph01: { type: String, default: '' },
    answerImage01: {type: String, default: ''},
    answerHeading02: { type: String, default: '' },
    answerParagraph02: { type: String, default: '' },
    answerImage02: {type: String, default: ''},
    answerHeading03: { type: String, default: '' },
    answerParagraph03: { type: String, default: '' },
    answerImage03: {type: String, default: ''},
    bannerFull: { type: String, default: '' },
    bannerFullSp: { type: String, default: '' },
    classCustom: { type: String, default: '' }
  },
  data(){
    return {}
  },
  mounted() {
    setTimeout(() => {
      this.handleAnimated()
    }, 800)

    setTimeout(() => {
      document.querySelector('.list').style.opacity = 1
    }, 2000)

    window.addEventListener('resize', this.handleAnimated)
  },
  methods: {
    handleAnimated(){
      const descriptions = document.querySelectorAll('.descriptions > p')
      descriptions.forEach((des, index) =>  {
        setTimeout(() => {
          des.classList.add('animated')
        }, 600 * index + 1)

      })
    }
  }
}
</script>

<template>
<section :class="[classCustom, 'container']">
    <div class="hero-banner">
     <div class="title">
       <div>
        <div>
          <div v-for="(char, index) in sort.split('')" :key="index">
            {{char}}
          </div>
        </div>
         <p>
           <span>{{title}}</span>
           <span>{{tags}}</span>
         </p>
       </div>
       <div class="descriptions">
         <p v-if="description01">{{description01}}</p>
         <p v-if="description02">{{description02}}</p>
         <p v-if="description03">{{description03}}</p>
       </div>
     </div>
      <div class="image">
        <picture>
          <source :srcset="banner"
                  media="(min-width: 901px)">
          <source :srcset="bannerSp"
                  media="(max-width: 900px)">
          <img :src="banner" alt="" />
        </picture>
      </div>
    </div>

    <ul class="list">
      <li>
        {{office}}
      </li>
      <li>
        {{name}}
      </li>
      <li>
        {{joinYear}}年⼊社
      </li>
    </ul>

  <recruit-info  :title="'⼊社の経緯'"  :heading="answerHeading01" :paragraph="answerParagraph01" :image="answerImage01"/>
  <recruit-info  title="仕事内容"  :heading="answerHeading02" :paragraph="answerParagraph02" :image="answerImage02" :is-reverse="true"/>

  <div class="bg-full column-picture">
    <picture>
      <source :srcset="bannerFull"
              media="(min-width: 901px)">
      <source :srcset="bannerFullSp"
              media="(max-width: 900px)">
      <img :src="bannerFull" :alt="answerHeading03" />
    </picture>
  </div>
  <div class="column">
    <div class="column-inner">
      <span>
        今後の目標
        <img src="@/assets/img/career/icon-arrow-right-blue.svg"  alt="⼊社の経緯"/>
      </span>
      <h3>{{answerHeading03}}</h3>
      <div>
        <p>{{answerParagraph03}}</p>
        <div>
          <picture>
            <source :srcset="answerImage03"
                    media="(min-width: 901px)">
            <source :srcset="answerImage03"
                    media="(max-width: 900px)">
            <img :src="answerImage03" :alt="answerHeading01" />
          </picture>
        </div>
      </div>
    </div>
  </div>
  <recruit-link />
</section>
</template>

<style scoped lang="scss">
.container{
  overflow-x: hidden;
}
.hero-banner{
  height: 600px;
  position: relative;
  padding: 42px 0;
  @media print, screen and (max-width: 900px) { height: 566px; }
  & > .title{
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 50%;
    left: 3.5%;
    z-index: 50;
    transform: translateY(-50%);
    transition: all ease-in-out 0.3s;
    @media print, screen and (max-width: 900px) {
      height: 100%;
      width: 100%;
      left: 0;
    }

    & > div {
      &:first-child{
        display: flex;
        align-items: flex-end;
        column-gap: 36px;
        transition: all ease-in-out 0.3s;

        @media print, screen and (max-width: 900px) {
          align-items: center;
          position: absolute;
          top: -2.7%;
          column-gap: 20px;
        }

        @media print, screen and (min-width: 767px) and (max-width: 899px) { top: -2.9% !important; }

        @media print, screen and (max-width: 900px) {
          top: -1.5%;
        }
        & > div{
          display: flex;
          align-items: center;
          font-size: 150px;
          font-family: 'Montserrat', sans-serif;
          font-weight: 500;
          letter-spacing: 5px;
          color: var(--darkBlue);
          line-height: normal;
          transition: all ease-in-out 0.3s;

          & > div{
            &:first-child{
              animation: sortSlideDown .5s ease-in-out;
            }

            &:last-child{
              animation: sortSlideDown .8s  ease-in-out;
            }
          }
          @media print, screen and (max-width: 900px) {
            font-size: 120px;
          }

          @media print, screen and (max-width: 900px) {
            font-size: 100px;
          }

          @media print, screen and (max-width: 456px) {
            font-size: 86px;
          }
        }

        & > p{
          margin: 0;
          padding-bottom: 38px;
          transition: all ease-in-out 0.3s;
          @media print, screen and (max-width: 900px) { padding: 0; }
          & > span {
            transition: all ease-in-out 0.3s 0.8s;
            color: white;
            background-color: var(--darkBlue);
            font-size: 21px;
            width: fit-content;
            padding: 0 16px;
            font-weight: 700;
            min-height: 24px;
            display: flex;
            align-items: center;
            @media print, screen and (max-width: 900px) {
              font-size: 15px;
            }
            &:first-child{
              animation: widthAnimated .5s ease-in-out;
            }
            &:last-child{
              animation: widthAnimated 1s ease-in-out;
              font-size: 15px;
              margin-top: -1px;
              white-space: nowrap;
              @media print, screen and (max-width: 900px) {
                font-size: 12px;
              }

              @media print, screen and (max-width: 474px) {
                white-space: pre-wrap;
                font-size: 10px;
              }
            }
          }
        }
      }

      &:last-child{
        margin-top: 48px;
        display: flex;
        flex-direction: column;
        row-gap: 20px;
        transition: all ease-in-out 0.5s;
        @media print, screen and (max-width: 900px) { margin: 0; position: absolute; bottom: 2%; row-gap: 14px;}
        & > p{
          font-weight: 700;
          font-size: 36px;
          color: #3C3C3C;
          padding: 0 16px;
          margin: 0;
          width: fit-content;
          display: flex;
          flex-direction: column;
          background-color: white;
          transition: all ease-in-out 0.5s;
          opacity: 0;


          @media print, screen and (max-width: 900px) {
             font-size: 26px;
            padding: 0 12px;
          }

          @media print, screen and (max-width: 476px) {
            font-size: 20px;
          }
        }
        & > .animated{
          opacity: 1;
          animation:
              typingAnimated .8s steps(40, end),
              blink-caret 0.25s step-end infinite;
        }
      }
    }
  }

  & > .image{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: 100%;

    & > picture{
      width: 91.5%;
      border-top-left-radius: 32px;
      border-bottom-left-radius: 32px;
      overflow: hidden;
      height: 100%;

      animation: imageSlideLeft 1s ease-in-out;

      & > img {
        width: 100%;
        height: 100%;
        object-fit: cover;

      }
    }
  }
}

.list{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 180px;
  max-width: 60%;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  transition: all ease-in-out 1s;
  opacity: 0;
  @media print, screen and (max-width: 900px) {
    margin-bottom: 112px;
    margin-top: 44px;
    justify-content: center;
    max-width: 100%;
  }
  & > li{
    color: #3C3C3C;
    font-weight: 700;
    font-size: 16px;
    &:first-child{
      padding-right: 45px;
      white-space: pre-line;
      line-height: normal;
      @media print, screen and (max-width: 900px) {
        padding-right: 36px;
        font-size: 12px;
      }

      @media print, screen and (max-width: 414px) {
        padding-right: 24px;
      }
    }

    &:nth-child(2){
      font-size: 20px;
      border-right-width: 1px;
      border-left-width: 1px;
      border-left-style: solid;
      border-right-style: solid;
      border-color: var(--darkBlue);
      padding: 1px 45px;
      @media print, screen and (max-width: 900px) {
        padding: 1px 36px;
        font-size: 16px;
      }

      @media print, screen and (max-width: 414px) {
        padding: 1px 24px;
      }
    }

    &:last-child{
      padding-left: 45px;
      @media print, screen and (max-width: 900px) {
        padding-left: 36px;
        font-size: 12px;
      }

      @media print, screen and (max-width: 414px) {
        padding-left: 24px;
      }
    }
  }
}

.bg-full{
  width: 100%;
  & > picture{
    & > img{
      width: 100%;
      object-fit: cover;
    }
  }
}

.column-picture{
  transition: all ease-in-out .5s;
  @media print, screen and (max-width: 900px) {
    aspect-ratio: 1;
    overflow: hidden;
    & > picture{
      width: 100%;
      height: 100%;
      & > img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }

}

.column{
  margin-top: 134px;
  transition: all ease-in-out .5s;
  @media print, screen and (max-width: 900px) {margin: 80px auto 0 auto; width: 90%;}
}

.column-inner{
  max-width: 850px;
  margin: 0 auto;
  width: 100%;
  transition: all ease-in-out .5s;
  @media print, screen and (max-width: 900px) {
    max-width: 100%;
  }

  & > span{
    font-size: 20px;
    font-weight: 700;
    color: var(--darkBlue);
    display: flex;
    flex-direction: column;
    line-height: normal;
    max-width: fit-content;
    padding: 0 20px;
    @media print, screen and (max-width: 900px) {
      font-size: 15px;
      padding: 0;
      & > img {
        max-width: 86px;
      }
    }
  }

  & > h3{
    font-size: 34px;
    font-weight: 700;
    margin: 36px 0 66px 0;
    color: #3C3C3C;
    padding: 0 20px;
    line-height: normal;
    white-space: pre-wrap;
    @media print, screen and (max-width: 900px) {
      font-size: 20px;
      margin-bottom: 32px;
      margin-top: 32px;
      padding: 0;
    }

    @media print, screen and (max-width: 456px) {
      font-size: 19px;
    }
  }

  & > div{
    @media print, screen and (max-width: 900px) {
      display: flex;
      flex-direction: column-reverse;
    }
    & > p{
      margin: 0 0 72px 0;
      font-size: 16px;
      font-weight: 500;
      color: #3C3C3C;
      padding: 0 20px;
      line-height: 36px;
      @media print, screen and (max-width: 900px) {
        font-size: 15px;
        padding: 0;
        margin-bottom: 108px;
        line-height: 200%;
      }
    }

    & > div{
      border-radius: 24px;
      overflow: hidden;
      display: block;
      aspect-ratio: 822/476;
      margin-bottom: 170px;
      @media print, screen and (max-width: 900px) {
        margin-bottom: 50px;
      }

      & > picture{
        height: 100%;
        width: 100%;
        & > img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
  }
}


@keyframes imageSlideLeft {
  0%{
    opacity: 0;
    transform: translateX(10%);

  }

  100%{
    opacity: 1;
    transform: translateX(0);
  }
}


@keyframes widthAnimated {
  0%{
    width: 0;
    max-width: fit-content;
    overflow: hidden;
    white-space: nowrap;
    padding: 0;
  }

  100%{
    width: 100% ;
    max-width: fit-content;
    overflow: hidden;
    white-space: nowrap;
  }
}

@keyframes sortSlideDown {
  from{
    opacity: 0;
    transform: translateY(-50%);
  }
  to{
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes typingAnimated {
  from { width: 0; white-space: nowrap; overflow: hidden; max-width: fit-content }
  to { width: 100%; white-space: nowrap; overflow: hidden; max-width: fit-content }
}
</style>
